import { Box, Stack, Typography } from '@mui/material';

/** Same shape as rows under LLM bias `data` / accordion entries */
export type LlmBiasTableRow = Record<string, unknown>;

type Props = {
  entries: LlmBiasTableRow[];
  title?: string;
  description?: string;
  /** When false, omits the top title/description (parent supplies section heading). */
  showIntro?: boolean;
};

/**
 * Multiple focused tables: overview, prompts & outputs — easier to scan than one wide grid.
 */
const BiasLlmRecordsTable = ({
  title = 'LLM bias — Request Data Analysis',
  description = 'Data is split into separate tables: a quick overview, then prompts and model outputs.',
  showIntro = true
}: Props) => {
  // const hasOtherColumns = otherTopLevelKeys.length > 0;

  // if (!entries.length) {
  //   return null;
  // }

  return (
    <Stack spacing={2}>
      {showIntro ? (
        <Box>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary" sx={{ mb: 0.5 }}>
            {title}
          </Typography>
          {description ? (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          ) : null}
        </Box>
      ) : null}

      {/* <TableSection
        step={1}
        title="Overview"
        description="High-level outcome per request (same signals as the chart summaries)."
      >
        <TableContainer sx={{ maxHeight: 360 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100' }}>#</TableCell>
                <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100' }}>Label</TableCell>
                <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100' }}>Verdict</TableCell>
                <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100' }}>Risk</TableCell>
                <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100' }} align="right">
                  Bias score
                </TableCell>
                <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100' }} align="right">
                  Non-wl
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {entries.map((_, idx) => {
                const s = summaries[idx];
                return (
                  <TableRow key={`ov-${idx}`} hover>
                    <TableCell>{idx + 1}</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>{s.label}</TableCell>
                    <TableCell>{s.verdict}</TableCell>
                    <TableCell>{s.risk}</TableCell>
                    <TableCell align="right" sx={{ fontFamily: 'ui-monospace, monospace' }}>
                      {s.score}
                    </TableCell>
                    <TableCell>{s.status}</TableCell>
                    <TableCell align="right">{s.nonWl}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </TableSection> */}

      {/* <TableSection
        step={2}
        title="Prompts & model outputs"
        description="Input prompt and generated outputs for each request."
      >
        <TableContainer sx={{ maxHeight: 520 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', width: 48 }}>#</TableCell>
                <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', minWidth: 120 }}>Label</TableCell>
                <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', minWidth: 200 }}>Prompt</TableCell>
                <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', minWidth: 240 }}>Model output(s)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {entries.map((raw, idx) => {
                const s = summaries[idx];
                const prompt = typeof raw.prompt === 'string' ? raw.prompt : cellDisplay(raw.prompt);
                const outputs = formatPromptOutputs(raw.prompt_outputs);
                return (
                  <TableRow key={`po-${idx}`} hover>
                    <TableCell>{idx + 1}</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>{s.label}</TableCell>
                    <TableCell sx={cellScrollSx}>{prompt || '—'}</TableCell>
                    <TableCell sx={cellScrollSx}>{outputs}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </TableSection> */}

      {/* {hasOtherColumns
        ? 'fff' // <TableSection
        : //   step={3}
          //   title="Other top-level fields"
          //   description="Remaining fields on each row (duplicates of overview may appear if also stored at root)."
          // >
          //   <TableContainer sx={{ maxHeight: 400 }}>
          //     <Table size="small" stickyHeader>
          //       <TableHead>
          //         <TableRow>
          //           <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100' }}>#</TableCell>
          //           <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100' }}>Label</TableCell>
          //           {otherTopLevelKeys.map(col => (
          //             <TableCell
          //               key={col}
          //               sx={{ fontWeight: 700, bgcolor: 'grey.100', minWidth: 100, maxWidth: 320 }}
          //               title={col}
          //             >
          //               {col}
          //             </TableCell>
          //           ))}
          //         </TableRow>
          //       </TableHead>
          //       <TableBody>
          //         {entries.map((raw, idx) => {
          //           const s = summaries[idx];
          //           return (
          //             <TableRow key={`ot-${idx}`} hover>
          //               <TableCell>{idx + 1}</TableCell>
          //               <TableCell sx={{ fontWeight: 600 }}>{s.label}</TableCell>
          //               {otherTopLevelKeys.map(k => (
          //                 <TableCell key={k} sx={cellScrollSx}>
          //                   {cellDisplay(raw[k])}
          //                 </TableCell>
          //               ))}
          //             </TableRow>
          //           );
          //         })}
          //       </TableBody>
          //     </Table>
          //   </TableContainer>
          // </TableSection>
          null} */}
    </Stack>
  );
};

export default BiasLlmRecordsTable;
